import { createAction, props } from '@ngrx/store';

export const setLanguageInit = createAction('[Applet Language] Set Applet Language Init', props<{ language: any }>());
export const setLanguageSuccess = createAction('[Applet Language] Set Applet Language Success', props<{ language: any, translations: any }>());
export const setLanguageFailed = createAction('[Applet Language] Set Applet Language Failed', props<{ error: any }>());
